import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";
import { Context, CreateContextRequest, UpdateContextRequest } from "./contexts.model";

@Injectable()
export class ContextsService {

	public constructor(
		private http: HttpClient,
	) {
	}

	public getAllContexts(): Observable<Context[]> {
		return this.http.get<Context[]>(`/backoffice/contexts`)
			.pipe(
				map((res: Context[]) =>
					res.sort((a, b) => a.originCode.localeCompare(b.originCode))
				)
			);
	}

	public getContext(originCode: string): Observable<Context> {
		return this.http.get<Context>(`/contexts/${originCode}`);
	}

	public createContext(context: CreateContextRequest): Observable<Context> {
		return this.http.post<Context>(`/backoffice/contexts`, context);
	}

	public updateContext(originCode: string, context: UpdateContextRequest): Observable<Context> {
		return this.http.put<Context>(`/backoffice/contexts/${originCode}`, context);
	}

	public deleteContext(context: Context): Observable<void> {
		return this.http.delete<void>(`/backoffice/contexts/${context.originCode}`);
	}

}
